var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"border-top bg-secondary text-light"},[_c('b-nav',{attrs:{"align":"center pt-5"}}),_c('p',[_vm._v("© 2021 Deep-Voice")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }